import { useMissionsTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Chip } from '@mui/material';
import React from 'react';
export const OigStatusChip = ({ oigStatus }) => {
    const { t } = useMissionsTranslation();
    if (oigStatus !== 'notVerified') {
        return null;
    }
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' } },
        React.createElement(Chip, { sx: { backgroundColor: themeColors.accent.red.subtlest, color: themeColors.accent.red.bold }, "data-test": 'oig-status-chip', label: t('shifts.oigFailed'), size: 'small', variant: 'filled' })));
};
